import React from 'react';

import clsx from 'clsx';
import { LaughBeamIcon } from '../../../../../icon/regular';
import { LaughBeamIcon as LaughSolid } from '../../../../../icon/solid';
import useStyles from './styles';
import { Mood } from './types';
import {Grid} from "@material-ui/core";

const GreatRecordAction = ({ mood }: Mood) => {
  const classes = useStyles();
  const isActive = mood === 'great';
  return (
    <Grid item className={clsx(classes.container, isActive && 'active')}>
      {
        mood
          ? isActive
            ? <LaughSolid className={clsx(classes.icon, classes.greatIcon)} />
            : <LaughBeamIcon className={classes.icon} />
          : <LaughBeamIcon className={clsx(classes.icon, classes.greatIcon)} />
      }
      Great!
    </Grid>
  );
};

export default GreatRecordAction;
